import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { CameraAltIcon } from './MuiIcons';

type Props = {
  src?: string | null;
  alt?: string;
  size?: number;
  radius?: number;
  sx?: any;
  placeholderText?: string;
};

const EntryImage: React.FC<Props> = ({ src, alt = 'entry image', size = 200, radius, sx, placeholderText }) => {
  const theme = useTheme();
  const defaultRadius = typeof theme?.shape?.borderRadius === 'number' ? `${theme.shape.borderRadius}px` : '4px';
  const borderRadius = typeof radius === 'number' ? `${radius}px` : (radius ? String(radius) : defaultRadius);
  const w = `${size}px`;
  const h = `${size}px`;

  if (!src) {
    return (
      <Box sx={{ width: w, height: h, borderRadius: borderRadius, bgcolor: 'grey.100', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', p: 1, overflow: 'hidden', textAlign: 'center', ...sx }}>
        <CameraAltIcon sx={{ fontSize: Math.round(size * 0.18), color: 'text.secondary' }} />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, textAlign: 'center' }}>{placeholderText ?? 'Update to add image'}</Typography>
      </Box>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      style={{ width: w, height: h, objectFit: 'cover', borderRadius: borderRadius, background: '#f5f5f5', display: 'block' }}
    />
  );
};

export default EntryImage;
